import React from "react";
import { SlidePages } from "../../components/slidePages";
import img from "../../assets/images/acc.png"; // Assuming you have an image for Accompagnement
import img1 from "../../assets/images/a1.png";
import img2 from "../../assets/images/a2.png";
import img3 from "../../assets/images/a3.png";
import img4 from "../../assets/images/a4.png";
import { IntroAcc } from "../../components/serviceDetails/introAcc";
import { Interventions } from "../../components/serviceDetails/intervention";
import acc1 from "../../assets/images/acc1.png";
import acc2 from "../../assets/images/acc2.png";
import acc3 from "../../assets/images/acc3.png";
import { Realisation } from "../../components/home/realisation";
import { DemandeDevis } from "../../components/home/demandeDevis";
import { Prestations } from "../../components/home/prestations";
import rea1 from "../../assets/images/rea1.png";
import rea2 from "../../assets/images/rea2.png";
import rea3 from "../../assets/images/rea3.png";
export const AccompagnementPage = () => {
  const items = [
    {
      icon: img1,
      text: "MaPrimeRénov",
    },
    {
      icon: img2,
      text: "Certificats d’économie d’énergie (CEE)",
    },
    {
      icon: img3,
      text: "TVA réduite à 5,5 %",
    },
    {
      icon: img4,
      text: "Éco-prêt à taux zéro",
    },
  ];
  const realisations = [
    {
      image: rea1,
      text: "isolation toiture",
    },
    {
      image: rea2,
      text: "isolation par l’exterieur",
    },
    {
      image: rea3,
      text: "isolation par l’interieur",
    },
  ];
  const prestations = [
    {
      icon: acc1,
      text: "Montage du dossier",
    },
    {
      icon: acc2,
      text: "Suivi administratif",
    },
    {
      icon: acc3,
      text: "Aide à la simulation",
    },
  ];
  return (
    <div>
      {" "}
      <SlidePages
        title={"Aides & accompagnement administratif"}
        description={
          "Vous pouvez financer une grande partie de vos travaux grâce aux aides de l’État. Habitat IDF vous accompagne dans chaque étape du dossier."
        }
      />
      <IntroAcc items={items} img={img} />
      <Interventions
        description={
          "Nous vous guidons pour obtenir toutes les aides disponibles, sans stress ni erreur"
        }
        prestations={prestations}
        title={"Notre service"}
      />
      <DemandeDevis
        title={"Calculez vos aides dès maintenant avec notre équipe !"}
      />
      <Prestations
        title={"D’autres services"}
        description={
          "Des solutions durables pour un habitat plus beau, plus sain et moins énergivore."
        }
      />
    </div>
  );
};
